import { FetchClient, JsonClient } from '@cvent/fetch';
import {
  withRetries,
  defaultRetryDelayHandler,
  withHttpKeepAlive,
  withOkayStatus,
  withTraces
} from '@cvent/fetch/middleware';

const defaultFetchClientOptions = {
  preRequest: [withHttpKeepAlive(), withTraces()],
  postResponse: [withRetries(), withOkayStatus()]
};

const withRetriesOptions = {
  preRequest: [withHttpKeepAlive(), withTraces()],
  postResponse: [withRetries({ delay: defaultRetryDelayHandler({ initialDelay: 500 }) }), withOkayStatus()]
};

export const fetchClient = new FetchClient(defaultFetchClientOptions);

export const jsonFetchClient = new JsonClient(defaultFetchClientOptions);

export const fetchClientWithRetries = new FetchClient(withRetriesOptions);

export const fetchClientWithTimeout = new FetchClient({ ...withRetriesOptions, timeout: 10000 });
